import type { MapRegion } from "@/types"

export const kazdelRegion: MapRegion = {
    id: "kazdel",
    name: "map.region.kazdel",
    mapImage: require("@/assets/imgs/map/kazdel/map-kazdel.png"),
    decoImage: require("@/assets/imgs/map/kazdel/map-kazdel-deco.png"),
    startNodeId: "kz-start",
    endNodeId: "kz-end",
    startDirection: "right",
    unlocked: false,
    order: 5,
    iconConfig: {
        question: {
            highlightIcon: require("@/assets/imgs/map/kazdel/map-kazdel-question-mark.png"),
            width: 207,
            height: 203,
        },
    },
    nodes: [
        {
            id: "kz-start",
            type: "start",
            level: 0,
            position: { x: 714, y: 706 },
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/kazdel/map-kazdel-furnace.png"),
                width: 370,
                height: 398,
            },
        },
        {
            id: "kz-w",
            type: "event",
            level: 1,
            position: { x: 990, y: 628 },
            eventId: "dlg-kz-w",
            iconType: "character",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/kazdel/map-kazdel-event-w.png"),
                width: 281,
                height: 287,
            },
        },
        {
            id: "kz-evt3",
            type: "event",
            level: 1,
            position: { x: 238, y: 680 },
            eventId: "evt-kz-03",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/kazdel/map-kazdel-event-3.png"),
                width: 398,
                height: 269,
            },
        },
        {
            id: "kz-evt4",
            type: "event",
            level: 1,
            position: { x: 712, y: 360 },
            eventId: "evt-kz-04",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/kazdel/map-kazdel-event-4.png"),
                width: 255,
                height: 344,
            },
        },
        {
            id: "kz-odda",
            type: "event",
            level: 2,
            position: { x: 237, y: 418 },
            eventId: "dlg-kz-odda",
            iconType: "character",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/kazdel/map-kazdel-event-odda.png"),
                width: 286,
                height: 292,
            },
        },
        {
            id: "kz-evt2",
            type: "event",
            level: 2,
            position: { x: 1196, y: 698 },
            eventId: "evt-kz-02",
            iconType: "question",
        },
        {
            id: "kz-evt5",
            type: "event",
            level: 3,
            position: { x: 212, y: 179 },
            eventId: "evt-kz-05",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/kazdel/map-kazdel-event-5.png"),
                width: 381,
                height: 276,
            },
        },
        {
            id: "kz-evt6",
            type: "event",
            level: 3,
            position: { x: 1328, y: 485 },
            eventId: "evt-kz-06",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/kazdel/map-kazdel-event-6.png"),
                width: 371,
                height: 312,
            },
        },
        {
            id: "kz-evt1",
            type: "event",
            level: 4,
            position: { x: 626, y: 176 },
            eventId: "evt-kz-01",
            iconType: "question",
        },
        {
            id: "kz-end",
            type: "end",
            level: 5,
            position: { x: 1388, y: 107 },
            playerAnchor: { x: -20, y: 40 },
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/kazdel/map-kazdel-target.png"),
                width: 199,
                height: 220,
            },
        },
    ],
    edges: [
        { from: "kz-start", to: "kz-w", waypoints: [] },
        { from: "kz-start", to: "kz-evt3", waypoints: [] },
        { from: "kz-start", to: "kz-evt4", waypoints: [] },
        { from: "kz-w", to: "kz-evt3", waypoints: [{ x: 714, y: 706 }] },
        { from: "kz-w", to: "kz-evt2", waypoints: [] },
        { from: "kz-w", to: "kz-evt4", waypoints: [{ x: 714, y: 706 }] },
        { from: "kz-evt3", to: "kz-odda", waypoints: [] },
        { from: "kz-evt3", to: "kz-evt4", waypoints: [{ x: 714, y: 706 }] },
        { from: "kz-evt4", to: "kz-odda", waypoints: [] },
        {
            from: "kz-evt4",
            to: "kz-evt6",
            waypoints: [
                { x: 1000, y: 360 },
                { x: 1000, y: 485 },
            ],
        },
        { from: "kz-odda", to: "kz-evt5", waypoints: [] },
        { from: "kz-evt2", to: "kz-evt6", waypoints: [] },
        { from: "kz-evt5", to: "kz-evt1", waypoints: [] },
        { from: "kz-evt6", to: "kz-end", waypoints: [] },
        {
            from: "kz-evt1",
            to: "kz-end",
            waypoints: [
                { x: 1050, y: 176 },
                { x: 1050, y: 147 },
            ],
        },
    ],
}
